<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row mb-4">
    <div class="col-12">
      <div>
        <ng-select
          [searchable]="false"
          [clearable]="false"
          [items]="unitTypes"
          formControlName="type"
          label="MENU.UTILITY_TYPES"
          inputValidator
        >
        </ng-select>
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProvidersService.getAll.bind(utilityProvidersService)"
          formControlName="utilityProviderId"
          bindLabel="name"
          inputValidator
          label="{{ 'MENU.UTILITY_PROVIDERS' | translate }}"
        />
      </div>
    </div>


  </div>

  <div class="text-end d-flex gap-2 justify-content-end">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
    <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
